import isEmpty from '../helpers/isEmpty'
//-------------------------------
// get populated skill max ticks
//-------------------------------
export default function getPopulatedSkillMaxTicks(args) {

// console.log('getPopulatedSkillMaxTicks args:', args)

  if (isEmpty(args.base) || isEmpty(args.training) || isEmpty(args.max_skill) || isEmpty(args.cur_no_adjs)) return null

  let max = 'Base (' + args.base + ') + Training (' + args.training + ')'
  max += '\nConstrained by:'
  max += '\nMax Skill (' + args.max_skill + ') -'
  max += '\nCurrent Skill (No Adjs) (' + args.cur_no_adjs + ')'
  return max
}